import { EmploymentStatus, PortalApiError } from '@afterpaytouch/portal-api'
import { PaymentOptionsError } from '../../model'

export interface RatesConfig {
  maxComparisonRate: string
  minComparisonRate: string
  maxInterestRate: string
}

export interface CLRiskDeclineError {
  isError: boolean
  error: PortalApiError | PaymentOptionsError | undefined
  reset: () => void
  context?: FacilityContext
}

export enum FacilityContext {
  PreAssessment = 'preAssessment',
  Assessment = 'assessment',
  FacilityCreation = 'facilityCreation',
  IncomeAssessment = 'incomeAssessment',
}

export interface AssessmentRequest {
  maxCreditLimit?: string
  employmentStatus?: EmploymentStatus
  changeInCircumstances?: boolean
}
